import React from 'react'
import { CurrentUser } from '~/views/contexts/CurrentUserContext'
import {
  getCodesFromCurrentUser,
  toLocalizedCurrencyNumber,
} from '~/utils/currency/currency'
import {
  CountryCodeEnumType,
  CurrencyCodeEnumType,
} from '~/common/types/graphql'

interface LocalizedCurrencyNumberProps {
  number: number | string
  countryCode?: CountryCodeEnumType
  currencyCode?: CurrencyCodeEnumType
  displayFractionDigits?: boolean
  errorText?: string
  currentUser: CurrentUser | null | undefined
}

const LocalizedCurrencyNumber = ({
  number,
  countryCode: paramCountryCode,
  currencyCode: paramCurrencyCode,
  displayFractionDigits = false,
  errorText = 'error :(',
  currentUser,
}: LocalizedCurrencyNumberProps) => {
  const { countryCode, currencyCode } = getCodesFromCurrentUser(currentUser)

  const countryCodeToUse = paramCountryCode || countryCode
  const currencyCodeToUse = paramCurrencyCode || currencyCode
  return (
    <>
      {toLocalizedCurrencyNumber({
        number,
        countryCode: countryCodeToUse,
        currencyCode: currencyCodeToUse,
        displayFractionDigits,
      }) || errorText}
    </>
  )
}

export default LocalizedCurrencyNumber
